import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  getWindow(): Window | null {
    return this.isBrowser ? window : null;
  }

  getDocument(): Document | null {
    return this.isBrowser ? document : null;
  }

  getNavigator(): Navigator | null {
    return this.isBrowser ? navigator : null;
  }

  getLocalStorage(): Storage | null {
    return this.isBrowser ? localStorage : null;
  }

  getSessionStorage(): Storage | null {
    return this.isBrowser ? sessionStorage : null;
  }

  isBrowserPlatform(): boolean {
    return this.isBrowser;
  }
}
